import base from './base'

const postOrder = (orderParams) => base
  .post('/orders', orderParams).then(resp => resp.data)

export default {
  postOrder: postOrder,
}
